import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../../../../services/popup.service';
import { MapService } from '../../../../../services/map.service';
import { MyStuffService } from '../../../../../services/my-stuff.service';
import { NotificationService } from '../../../../../services/notification.service';
import { UserService } from '../../../../../services/user.service';
import { environment } from '../../../../../../environments/environment';
import { RemovedItemsService } from '../../../../../services/removed-items.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-maps-all',
  templateUrl: './maps-all.component.html',
  styleUrls: ['./maps-all.component.less']
})
export class MapsAllComponent implements OnInit {
  GOOGLE_CLIENT_ID = environment.APP.GOOGLE_CLIENT_ID;
  API_URL = environment.APP.API_URL;
  mapsDetailElement: any;
  isDropdownOpen: any = {};

  constructor(public popupService: PopupService, public mapService: MapService, public myStuffService: MyStuffService,
   public notificationService: NotificationService, public userService: UserService, public removedItemsService : RemovedItemsService) { }

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.allMaps) {
      this.myStuffService.fetchAllMapsSource.next(true);
      this.myStuffService.myStuffSectionOpened.allMaps = true;
    }
  }

  openDropdown(index) {
    this.closeAllDropdowns();
    this.isDropdownOpen[index] = !this.isDropdownOpen[index];
    (<any>window).Events.publish('detectChanges')
  }

  closeAllDropdowns() {
    Object.keys(this.isDropdownOpen).map((index)=>{
      if(this.isDropdownOpen[index]) {
        this.isDropdownOpen[index] = false;
      }
    });
  }

  closeDropdown(index) {
    this.isDropdownOpen[index] = !this.isDropdownOpen[index];
    (<any>window).Events.publish('detectChanges');
  }

  toggleShareMap(map) {
    this.userService.onSingleMapClick(map);
    if(!this.popupService.popupList.popups['share-map']) {
      (!this.mapService.isMapReceived)?
      this.popupService.updateRoute('share-map'):
      this.notificationService.info('You cannot edit received map.');
    } else {
      this.popupService.updateRoute();
    }
  }

  deleteUserMap(index) {
    this.mapService.deleteMap(this.mapService.userMaps.allMaps[index].id).subscribe((response)=>{
      this.mapService.closeIfMapActive(this.mapService.userMaps.allMaps[index].id);
      this.notificationService.info('Your map has been Deleted');
      this.myStuffService.fetchAllMapsSource.next(true);
      this.removedItemsService.fetchAllRemovedItemsSource.next(true);
    },
    (error)=>{
      throw(error);
    });
  }

  paginate() {
    if(this.mapService.userMaps.allMaps.length > 0) {
      this.myStuffService.getMaps(this.myStuffService.mapCallFilters.allMaps);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/maps-section/maps-all/maps-all.component.ts